import { render, staticRenderFns } from "./UserStory.vue?vue&type=template&id=5b2d19c0&"
import script from "./UserStory.vue?vue&type=script&lang=js&"
export * from "./UserStory.vue?vue&type=script&lang=js&"
import style0 from "./UserStory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports